export default __webpack_public_path__ + "static/media/switch.15b99ce1.svg";